export enum EApiCallStateNames {
  DASHBOARD_DIARY = 'DASHBOARD_DIARY',
}
export enum EApiRequestPartKeys {
  FILTERS = 'FILTERS',
}
